const UPLOAD_URL = process.env.REACT_APP_UPLOAD_URL;

// Use Strapi's resized formats so the browser downloads an image sized to the tile
// instead of the full original upload.
export const buildSrcSet = (img) => {
    if (!img) return undefined;
    const variants = ["small", "medium", "large"]
        .map((key) => img.formats?.[key])
        .filter(Boolean);
    if (img.width) variants.push(img);
    return variants.length ? variants.map((v) => `${UPLOAD_URL}${v.url} ${v.width}w`).join(", ") : undefined;
};
